import type { FaireProductEntity } from "../../entity_types/product";

export const p_pbuddrhsz8: FaireProductEntity = {
  token: "p_pbuddrhsz8",
  type: "product",
  name: "Book Nerd Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/e1a30ff0c890784bd79e6a52af9a08b37f566a3d8d6feb757e192fc6aa06f5b5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a3d2d651dbe51567409f78b2f3f286fdf70b4662d8f13668bc3ee7d29064c1f.jpeg",
    "https://cdn.faire.com/fastly/f8a6d40b343bfcffaef032d6d83e29852002b88392806611332422f0b283ea75.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/45b5ef7bce9b62bdbb4c4ce68d97ef2e7f5a223c1f9cf5cc27bd50096dea130b.jpeg",
    "https://cdn.faire.com/fastly/39613ff21c778c448e7fbc3652ffb4c4d448e0295d71e951924882afbf67985b.jpeg"
  ],
  priceDollars: 6.75,
  description: "When your bookshelf weighs as much as your bed, your dreams come as easily from either place. Pop on these socks and crack open another one as you finally admit to yourself, you're a Book Nerd. 📖\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:13.984Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
